/**
 * Analytics helper plugin
 * @param  {Object} Vue
 * @param  {Object} options
 * @return {Function}
 */
module.exports.install = (Vue, options) => {
  const state = options.store.state

  Vue.prototype.$analytics = {
    /**
     * Begin analytics session
     */
    begin () {
      this.event('SessionStart')
    },

    /**
     * End analytics session
     */
    end () {
      this.event('SessionEnd')
    },

    /**
     * Track an analytics event
     * @param {String} name The event name
     * @param {Object} payload Analytics data to send
     */
    event (name, payload) {
      Vue.$ga.page(endpoint() + name)
    }
  }

  function endpoint () {
    return `/Petbook/Suite${state.suite.suiteNumber}/Animal${state.animal.id.replace('animal-', '')}/`
  }
}



// WEBPACK FOOTER //
// ./src/plugins/analytics.js